import React, { FC, memo } from 'react'

import { Title } from '@Components/CMS/Title'
import { ShippingText } from '@Components/Shipping/ShippingInfoModal/ShippingText'
import { useTranslation } from '@Globals/Translations'

interface ShippingPolicyProps {
  center?: boolean
}

export const ShippingPolicy: FC<ShippingPolicyProps> = memo(({ center }) => {
  const { t } = useTranslation()

  return (
    <ShippingText center={center}>
      <Title className="policy_title" title={t('header:DELIVERY_POLICY_TITLE')} type="h3" />
      <span>{t('header:DELIVERY_POLICY_TEXT')}</span>
    </ShippingText>
  )
})
